import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import * as DataActions from '../../../ngrx/data/data.actions';

const LOCATION_TABLE_KEYS = [
  'locations',
  'locations_admin',
  'locations_suggested',
  'locations_suggested_admin',
  'rooms',
  'rooms_admin'
] as const;

/** Dispatch reload for all location-related table data sources (after mutations). */
export function refreshAllLocationTableStores(componentDataSourceService: ComponentDataSourceService): void {
  LOCATION_TABLE_KEYS.forEach((k) =>
    componentDataSourceService.store.dispatch(DataActions.loadData({ dataSourceKey: k }))
  );
}

/** Lets duna-locations-and-rooms close dialogs and run ViewChild table refresh. */
export function notifyDunaLocationsAdminFormSuccess(): void {
  window.dispatchEvent(new CustomEvent('duna-locations-admin-form-success'));
}
